import { LatestNoPlanReminder } from "../services/types/plans-service.types";
import { VoyagePlan } from "./vessel-planning-model";

export abstract class VoyagePlansModelBase extends EventTarget
{
    abstract getPlans(imoNo: number): Map<string, VoyagePlan>|null;
    abstract choosePlan(imo: number): VoyagePlan|null;
    abstract syncPlans(imoNo: number, date: Date): Promise<void>;
    abstract syncLatestNoPlanReminder(imoNo: number): void;
    abstract getLatestNoPlanReminder(imoNo: number): LatestNoPlanReminder|null;
}

let VoyagePlansModel: VoyagePlansModelBase|null = null;

function setVoyagePlansModel(model: VoyagePlansModelBase)
{
    VoyagePlansModel = model;
}

export { VoyagePlansModel, setVoyagePlansModel };

// those constants should match the ones in voy-plans
export enum PlanSource {
    ECOVOYAGE = "EcoVoyage",
    PASSAGE_PLAN = "PassagePlan",
    VOYAGE_PLANNING = "VoyagePlanning",
    EXCEL_PLAN = "ExcelPlan",
    VOYAGE_BASIC_ROUTE_NOT_OPTIMIZED = "RouteNotOptimized"
}
